import appApi from 'config/app-api';

import type { ICalculateWidgetResult, IWidgetCurrency, IWidgetItem } from './widget.model';

export interface ICalculateWidget {
  uuid: string;
  amount?: string;
  is_subtract?: boolean;
  payment_currency?: string;
}
export const WidgetService = {
  async calculateWidget(data: ICalculateWidget) {
    return appApi.post<{
      result: ICalculateWidgetResult;
    }>('v2/widget/public/calculate', { ...data, network: 'tron' });
  },

  async createInvoice(data: ICalculateWidget) {
    return appApi.post<{
      result: {
        redirect: string;
      };
    }>('v2/widget/public/create_invoice', { ...data, network: 'tron' });
  },

  async getCurrencyList(widget_id: string, search?: string) {
    return appApi.get<{ result: IWidgetCurrency[] }>(`v2/widget/public/currency_list/${widget_id}`, {
      params: {
        search,
      },
    });
  },

  async getWidgetInfo(widgetId: string) {
    return appApi.get<{
      result: IWidgetItem;
    }>(`v2/widget/public/info/${widgetId}`);
  },
};
